import NavBar from "../NavBar/NavBar";
interface EmptyPageProps {
  title: string;
  subtitle: string;
}
const EmptyPage: React.FC<EmptyPageProps> = ({ title, subtitle }) => {
  return (
    <main>
      <NavBar name={"عدم وجود اطلاعات"} />
      <div className="w-full border-b border-t">
        <div className="flex items-center justify-center h-screen">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">{title}</h1>
            <p className="text-lg">{subtitle}</p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default EmptyPage;
